<form [formGroup]="formGroup">
    <table mat-table [dataSource]="translationsFormArray.controls" class="table table-sm table-bordered">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef style="width: 300px">
                {{ 'aumico_admin_translations_name_column_header' | i18next }}
            </th>
            <td mat-cell *matCellDef="let rowFormGroup" [formGroup]="rowFormGroup">
                {{ rowFormGroup['controls']['name'].value }}
            </td>
        </ng-container>

        <ng-container matColumnDef="currentLocale">
            <th mat-header-cell *matHeaderCellDef>{{ currentLocale }}</th>
            <td mat-cell *matCellDef="let rowFormGroup" [formGroup]="rowFormGroup">
                <aum-input [aumFormControl]="rowFormGroup['controls']['currentLocale']"></aum-input>
            </td>
        </ng-container>

        <ng-container matColumnDef="selectedLocale">
            <th mat-header-cell *matHeaderCellDef>{{ selectedLocale }}</th>
            <td mat-cell *matCellDef="let rowFormGroup" [formGroup]="rowFormGroup">
                <aum-input [aumFormControl]="rowFormGroup['controls']['selectedLocale']"></aum-input>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</form>
